function createBoardEditing() {
  const state = { active: false, busy: false, dragging: false };
  let session = 0;
  return {
    state,
    get locked() { return state.busy || state.dragging; },
    setActive(value) {
      if (!this.locked) state.active = Boolean(value);
    },
    reset() {
      state.active = false;
      state.dragging = false;
      session++;
    },
    beginDrag() {
      if (!state.active || this.locked) return false;
      state.dragging = true;
      return true;
    },
    endDrag() { state.dragging = false; },
    async run(action) {
      if (!state.active || this.locked) {
        const message = this.locked ? 'Aguarde a operação em andamento.' : 'Ative o modo edição para realizar esta ação.';
        throw Object.assign(new Error(message), { response: { status: 403, data: message } });
      }
      const currentSession = session;
      state.busy = true;
      try {
        const result = await action({ headers: { 'X-Edit-Mode': 'true' } });
        if (currentSession !== session) throw new Error('A sessão foi alterada.');
        return result;
      } finally {
        state.busy = false;
      }
    }
  };
}

module.exports = { createBoardEditing };
